// extracted by mini-css-extract-plugin
module.exports = {"container":"Politics_container__2AbQh","text":"Politics_text__1JZU7","title":"Politics_title__24iU_"};